export default "__VITE_ASSET__DjUEvKFP__"